module.exports = __webpack_public_path__ + "media/home01.df60fb94.webm";